'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Header = _interopRequireDefault(require("Components/Navigation/Header"));
var _Footer = _interopRequireDefault(require("Components/Navigation/Footer"));
var _CookiesAlert = _interopRequireDefault(require("Components/Cookies/CookiesAlert"));
var _reactHelmet = require("react-helmet");
var _setCookiesParam = _interopRequireDefault(require("Components/StoresFunctions/setCookiesParam"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _config = require("Shared/config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class Front extends _react.Component {
  state = {};
  pathname = document.location.pathname;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.pathname = document.location.pathname;
    (0, _setCookiesParam.default)('google_analytics', {
      id: _config.google_analytics
    });
    component.fetchMetas();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (document.location.pathname !== component.pathname) {
      (0, _setCookiesParam.default)('google_analytics', {
        id: _config.google_analytics
      });
      component.pathname = document.location.pathname;
      component.fetchMetas();
    }
  }
  clickDocument = () => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'documentClick'
    });
  };
  fetchMetas = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/fetch-metas', {
      pathname: document.location.pathname
    }).then(function (xhr, response) {
      component.setState({
        metas: response.metas
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  onClick = e => {
    e.persist();
    app.emit({
      event: 'documentClick',
      source: 'document',
      data: {
        e: e
      }
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const meta_tags = state.metas ? /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, state.metas.title), /*#__PURE__*/_react.default.createElement("link", {
      rel: "canonical",
      href: state.metas.canonical
    }), /*#__PURE__*/_react.default.createElement("meta", {
      name: "description",
      content: state.metas.description
    }), /*#__PURE__*/_react.default.createElement("meta", {
      property: "og:url",
      content: state.metas.canonical
    }), /*#__PURE__*/_react.default.createElement("meta", {
      property: "og:title",
      content: state.metas.title
    }), /*#__PURE__*/_react.default.createElement("meta", {
      name: "og:description",
      content: state.metas.description
    }), state.metas.image ? /*#__PURE__*/_react.default.createElement("meta", {
      property: "og:image",
      content: state.metas.image
    }) : undefined, props.meta_follow === true ? /*#__PURE__*/_react.default.createElement("meta", {
      name: "robots",
      content: "index, follow"
    }) : /*#__PURE__*/_react.default.createElement("meta", {
      name: "robots",
      content: "noindex, nofollow"
    })) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "front-page",
      onClick: component.onClick
    }, meta_tags, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement("div", {
      className: "front-page__content"
    }, props.children), /*#__PURE__*/_react.default.createElement(_Footer.default, null), /*#__PURE__*/_react.default.createElement(_CookiesAlert.default, null));
    return output;
  }
}
exports.default = Front;
